import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { AlertService } from 'ngx-alerts';
import { NgxSpinnerService } from 'ngx-spinner';
import { Client, SeguimientoRespuestaExtendedDto } from '../../services/client';
import { errorMessages } from '../../../../../src/assets/constants.json';

@Component({
	selector: 'app-seguimiento-solicitud',
	templateUrl: './seguimiento-solicitud.component.html'
})
export class SeguimientoSolicitudComponent implements OnInit {

	@Input() seguimientoIndex = undefined;
	@Input() disabled = false;
	@Input() seguimiento: SeguimientoRespuestaExtendedDto = new SeguimientoRespuestaExtendedDto();
	@Output() seguimientoEnviado = new EventEmitter();

	formTitle: string;
	seguimientoForm: FormGroup;
	submitSuccessful = false;
	respuestaId: number = null;
	testFecha;
	testHora;

	constructor(
		public router: Router,
		public route: ActivatedRoute,
		public client: Client,
		private fb: FormBuilder,
		private spinner: NgxSpinnerService,
		private alertService: AlertService
	) {
		this.seguimientoForm = this.fb.group({
			accionTomada: [null],
			accionTomadaOtra: [null, Validators.maxLength(100)],
			seTomoAlgunaAccion: ['', Validators.required],
			explicacionNoSeTomoAccion: ['', Validators.required],
			fecha: ['', [Validators.required, Validators.maxLength(50)]],
			casoResuelto: ['', Validators.required]
		});
	}

	ngOnInit() {
		this.route.queryParams.subscribe((data) => {
			this.respuestaId = data['respuestaId'];
		});

		if (!!this.seguimiento.id) {
			this.seguimientoForm.setValue({
				accionTomada: this.seguimiento.accionTomada,
				accionTomadaOtra: this.seguimiento.accionTomadaOtra,
				seTomoAlgunaAccion: this.seguimiento.seTomoAlgunaAccion,
				explicacionNoSeTomoAccion: this.seguimiento.explicacionNoSeTomoAccion,
				fecha: this.seguimiento.fecha,
				casoResuelto: null
			});
		}
	}

	onSubmit() {
		const form = this.seguimientoForm.getRawValue();
		this.spinner.show();
		this.client.respuestas_PostSeguimientoRespuesta(this.respuestaId, form)
			.finally(() => {
				this.spinner.hide();
				this.seguimientoForm.reset();
			})
			.subscribe((data: any) => {
				this.submitSuccessful = true;
				this.alertService.success('Seguimiento enviado satisfactoriamente.');
				this.seguimientoEnviado.emit(form);
			}, (error) => {
				this.spinner.hide();
				const errorMessage = error.status === 0 ?
					errorMessages.connectionError : !!error.title ? error.title : errorMessages.genericError;
				this.alertService.danger(errorMessage);
			});
	}

	volver() {
		return this.router.navigate(['admin/entregas/lista']);
	}
}
